module.exports = __webpack_public_path__ + "img/navigation_htwl1.d3255a6f.png";